/**
 *
 * @param axiosError
 * @returns LogEntryMetaData
 */
export const getErrorObject = (error: any) => {
    let logEntryMetaData = {};
    //guard
    if (!(error && error?.response)) {
        return '';
    }
    try {
        const config = {
            data: error.response.config?.data,
            headers: error.response.config?.headers,
        };
        const response = {
            data: error.response.data,
            headers: error.response.headers,
            status: error.response.status,
        };
        logEntryMetaData = {
            associatedRequestId: error.headers.get('x-amzn-requestid'),
            errorStatusCode: error.response.status,
            errorMessage: error.message,
            errorStack: error.stack,
            errorRequestUrl: window.location.href,
            customField1: JSON.stringify({ config }),
            customField2: JSON.stringify({ response }),
        };
        return logEntryMetaData;
    } catch (error) {
        return logEntryMetaData;
    }
};
